/** API types for installation configuration (greenfield catalogs). */

export type InstallationConfigurationRowBase = {
  id: string
  installationId: string
  createdAt: string
  updatedAt: string | null
  deletedAt: string | null
}

export const precursorSupplyOriginValues = ['INTERNAL', 'EXTERNAL', 'BOTH'] as const

export type InstallationPrecursorSupplyOrigin =
  (typeof precursorSupplyOriginValues)[number]

export type InstallationPrecursorCnCodeDto = InstallationConfigurationRowBase & {
  cnCode: string
  supplyOrigin: InstallationPrecursorSupplyOrigin
  sourceGroupCount: number
}

export type InstallationProducedCnCodeDto = InstallationConfigurationRowBase & {
  cnCode: string
  cbamRelevant: boolean
}

export type InstallationFuelDto = InstallationConfigurationRowBase & {
  fuelTypeId: string
}

export type InstallationScrapCategoryDto = InstallationConfigurationRowBase & {
  name: string
}

export type InstallationOtherMaterialCategoryDto =
  InstallationConfigurationRowBase & {
    name: string
  }

export type CombustionFuelTypeDto = {
  id: string
  name: string
  emissionFactor: number
  netCalorificValue: number | null
  source: string
}

export type OperatorConfigDto = {
  combustionFuelTypes: CombustionFuelTypeDto[]
}
